//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      formList: [
        { typeName: "oldPW", langKey: "mine.loginPassword.oldPW" , plsLangKey:'mine.loginPassword.subTitle1' },
        { typeName: "newPW", langKey: "mine.loginPassword.newPW" , plsLangKey:'mine.loginPassword.subTitle2'},
        { typeName: "confirmNew", langKey: "mine.loginPassword.confirmNew" , plsLangKey:'mine.loginPassword.subTitle3'},
      ],
      ruleForm: {
        oldPW: "",
        newPW: "",
        confirmNew: "",
      },
      rules: {
        oldPW: [
          { required: true, message: this.$t('mine.loginPassword.oldPWRequired'), trigger: "change" },
        ],
        newPW: [
          { required: true, message: this.$t('mine.loginPassword.newPWRequired'), trigger: "change" },
          { pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/, message:this.$t('mine.loginPassword.pwdError'), trigger: 'change' },
        ],
        confirmNew: [
          { required: true, message: this.$t('mine.loginPassword.confirmNewRequired'), trigger: "change" },
          { validator: (rule, value, callback) => this.validateConfirmpassword(rule, value, callback), trigger: "change" },
        ],
      },
    };
  },
  methods: {
    handleSubmit() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.$emit("submit", this.ruleForm);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    validateConfirmpassword(rule, value, callback) {
      if (value !== this.ruleForm.newPW) {
        callback(new Error(this.$t('mine.loginPassword.epeatPassword2')));
      } else {
        callback();
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/build821/views/components/ChangePasswordForm.vue